import { useQuery, useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { App } from "antd";

import { checkApp, appConnect } from "apis/app";

export function useCheckApp({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["checkApp", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await checkApp(payload.app);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export const useAppConnect = () => {
  return useMutation((payload) => appConnect(payload.app));
};
